export default __webpack_public_path__ + "static/media/waves.ac46eaef.png";